<ul
  class="p-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-1.5 gap-y-3 sm:gap-x-3 md:gap-y-5 lg:gap-x-5"
>
  @for (item of categories(); track item.link) {
    <li
      class="max-md:nth-[n+10]:hidden max-sm:nth-[n+7]:hidden hover:scale-103 transition-all"
    >
      <a
        [routerLink]="item.link"
        class="card card-border items-center justify-around px-1 pt-4 pb-2 border-white-a/25 lg:px-3 block space-y-1 sm:space-y-2 h-full"
      >
        <img
          loading="lazy"
          [src]="mediaUrl(item.image)"
          [alt]="item.title"
          class="w-5/6 aspect-5/6 rounded object-contain object-center mx-auto"
        />
        <p
          class="font-medium text-xs lg:text-lg text-center grow lg:min-h-16 lg:flex lg:items-center lg:justify-center"
        >
          <span>
            {{ item.title }}
          </span>
        </p>
      </a>
    </li>
  }
</ul>
